import {isFeatureEnabled} from 'feature-flags';

import {isNil} from 'ramda';

import {ProtectedGroupResponseBody} from '@dms/api/security';

import {resolveAclFeatureFlag} from './resolveAclFeatureFlag';

export const filterResourcesByFeatureFlag = (data: ProtectedGroupResponseBody[]) => {
  const isResourceEnabled = (resource: ProtectedGroupResponseBody) => {
    const featureFlag = resolveAclFeatureFlag(resource.id);
    if (isNil(featureFlag)) {
      return true;
    }

    return isFeatureEnabled(featureFlag);
  };

  const filterResources = (resources: ProtectedGroupResponseBody[]): ProtectedGroupResponseBody[] =>
    resources
      .filter(isResourceEnabled)
      .map((resource) => ({...resource, children: filterResources(resource.children)}));

  return filterResources(data);
};
